import { Routes } from '@angular/router';
import { LogInComponent } from './auth/log-in/log-in.component';
import { AuthGuard } from './auth/auth.guard';
import { DashboardComponent } from './main/dashboard/dashboard.component';
import { WorkTaskListComponent } from './main/work-task-list/work-task-list.component';
import { FinishedTaskListComponent } from './main/finished-task-list/finished-task-list.component';
import { TridyListComponent } from './main/tridy-list/tridy-list.component';
import { environment } from '../environments/environment';

export const environmentName = environment.firebase;
export var devEnv: boolean = false;

if(environmentName.projectId=="narravero-eu-dev" || environmentName.projectId=="narravero-eu-test"){
  devEnv=true
}

export const routes: Routes = [
  {
    path: 'login',
    component: LogInComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'tasks', component: WorkTaskListComponent },
      { path: 'tasks/:id', component: WorkTaskListComponent },
      { path: 'finished-tasks', component: FinishedTaskListComponent },
      { path: 'finished-tasks/:id', component: FinishedTaskListComponent },
      ...(devEnv ? [
        { path: 'tridys', component: TridyListComponent },
        { path: 'tridys/:id', component: TridyListComponent },
      ] : []),
    ],
  },
  { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
];

